var map = {
	"./level-1.png": 67075,
	"./level-10.png": 81394,
	"./level-2.png": 54859,
	"./level-3.png": 91202,
	"./level-4.png": 83997,
	"./level-5.png": 62868,
	"./level-6.png": 85327,
	"./level-7.png": 16582,
	"./level-8.png": 56385,
	"./level-9.png": 83672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73986;